import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import WorkflowDashboard from "./WorkflowDashboard";
import ActiveWorkflows from "./ActiveWorkflows";
import WorkflowLibrary from "./WorkflowLibrary";
import WorkflowBuilder from "./WorkflowBuilder";

// Every tab is permission gated, so the tab that opens first depends on the user.
const tabs = [
    { key: 'wfDashboard', label: 'Workflow Dashboard', permission: 'WorkflowDashboardTab' },
    { key: 'activeWfs', label: 'Workflow Instances', permission: 'ActiveWorkflowsTab' },
    { key: 'wfLibrary', label: 'Workflow Library', permission: 'WorkflowLibraryTab' },
    { key: 'wfBuilder', label: 'Workflow Builder', permission: 'WorkflowBuilderTab' },
];

export default function Workflows(props) {
    const allowedTabs = tabs.filter((tab) => props.user.permissions[tab.permission]);
    const [activeKey, setActiveKey] = useState(allowedTabs[0]?.key);

    const handleKeyChange = (event, activeKey) => {
        setActiveKey(activeKey);
    };

    return (
        <Box sx={{ height: 'calc(100vh - 85px)', display: 'flex', flexDirection: 'column' }}>
            <Tabs
                value={activeKey ?? false}
                onChange={handleKeyChange}
                variant="scrollable"
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    '& .Mui-selected': {
                        backgroundColor: '#f0f0f0',
                        fontWeight: 'bold',
                    },
                }}
            >
                {allowedTabs.map((tab) => <Tab key={tab.key} value={tab.key} label={tab.label} />)}
            </Tabs>

            <Box sx={{ flex: 1, minHeight: 0 }}>
                {activeKey === "wfDashboard" && <WorkflowDashboard {...props} />}
                {activeKey === "activeWfs" && <ActiveWorkflows {...props} />}
                {activeKey === "wfLibrary" && <WorkflowLibrary {...props} />}
                {activeKey === "wfBuilder" && <WorkflowBuilder {...props} />}
            </Box>
        </Box>
    );
};
